/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from "@/store/store";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        
        // =============================================================================
        // PAGES
        // =============================================================================
        {
            path: '/',
            name: 'home',
            component: () => import('@/views/story/Stories.vue'),
        }, {
            path: '/home',
            name: '/home',
            component: () => import('@/views/story/Stories.vue'),
        }, {
            path: '/pages/error-404',
            name: 'page-error-404',
            component: () => import('@/views/pages/Error404.vue'),
        }, {
            path: '/pages/test',
            name: 'test',
            component: () => import('./views/tests/Test.vue'),
        }, {
            path: '/pages/testpage',
            name: 'testpage',
            component: () => import('./views/tests/TestPage.vue'),
        },
    
        // Stories
        {
            path: '/stories/',
            name: 'stories',
            component: () => import('./views/story/Stories.vue'),
        },
        // Story
        {
            path: '/story/',
            name: 'storie',
            component: () => import('./views/story/Story.vue'),
        },
        {
            path: '/story/:storyId',
            name: 'storie-id',
            component: () => import('./views/story/Story.vue'),
        },
        
        // Interactive Image
        {
            path: '/story/:storyId/interactive-image/',
            name: 'interactive-image',
            component: () => import('./views/interactives-images/InteractiveImage.vue'),
        },
        {
            path: '/story/:storyId/interactive-image/:id',
            name: 'interactive-image/id',
            component: () => import('./views/interactives-images/InteractiveImage.vue'),
        },
        
        // Video
        {
            path: '/story/:storyId/video/',
            name: 'video',
            component: () => import ('./views/video/Video'),
        },
        {
            path: '/story/:storyId/video/:id',
            name: 'video/id',
            component: () => import ('./views/video/Video'),
        },
        
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

export default router
